import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { FishSaleCreate } from '@/types/fish-sale';
import { NewProduct } from '@/types/product';

/**
 * Обновляет запись о продаже товара
 * @param fishSale
 */
export async function updateFishSale(fishSale: FishSaleCreate) {
	const token = cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.put<NewProduct>(
		`${process.env.HOST}/api_v1/sell-fish/${fishSale.id}/`,
		fishSale,
		{ headers: { Authorization: `Bearer ${token}` } },
	);

	return data;
}
